//LL: 15.07.20: copied (moved) from /common/application to /platform

import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { ProgressBar } from './ProgressBar';
import * as ConfigurationConstants from '../ts/ConfigurationConstants';
import { ColorBoxField } from './ColorBoxField';
import { IValuesCollection } from '../ts/appTheme';
import { IGlob } from '../../../pdc-platform/src/ts/Glob';

interface IProps {
    attrColorMapping: any;
    attribute: string;
    dataSourceID: number;
    parentColors?: any; //LL: 10.10.20: try parentColors
    theme?: IValuesCollection;
    themeObj?: IValuesCollection; //LL: 08.11.19  from EntityColorSelect.tsx   Use it
    onChange?: Function;
    glob: IGlob;
}

const GET_KEY_ATTRIBUTE_FOR_VALUES = true;

export class AttrValueColorSelect extends React.Component<IProps, {}> {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.glob.AttrQueryStore.addChangeListener(this.handleEntityModelsStoreChange);
    }

    componentWillUnmount() {
        this.props.glob.AttrQueryStore.removeChangeListener(this.handleEntityModelsStoreChange);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.attribute !== this.props.attribute) {
            this.props.glob.EntityModelsActions.loadEntityValues(
                this.props.dataSourceID,
                this.props.themeObj, //  this.props.theme  //LL: 30.01.20
                {
                    attribute: this.props.attribute,
                    loadKeyAttribute: GET_KEY_ATTRIBUTE_FOR_VALUES,
                    runTimeWidgetID: undefined //EVG: I set it explicitly to show where it should be set when needed.
                }
            );
        }
    }

    handleEntityModelsStoreChange = () => {
        this.setState(this.state);
    };

    getEntityCollection() {
        return this.props.glob.AttrQueryStore.getEntityValueCollection(this.props.dataSourceID, {
            attribute: this.props.attribute,
            loadKeyAttribute: GET_KEY_ATTRIBUTE_FOR_VALUES
        });
    }

    private undef_key = ConfigurationConstants.COLOR_MAP_UNDEF_KEY; //LL: 19.05.17  "__undefined"
    private defaultColor = ConfigurationConstants.COLOR_MAP_UNDEF_COLOR; //LL: 02.03.20    and not undefined color !

    _getDictionary = () => {
        let entityCollection = this.getEntityCollection();

        let values = []; // {};  //LL: comment: entityCollection.values is array, not object

        let isNotEmpty = entityCollection != undefined && entityCollection.values != undefined;
        if (isNotEmpty) {
            values = entityCollection.values;
        }

        let valuesCollection = {};

        if (isNotEmpty) {
            valuesCollection[this.undef_key] = this.defaultColor;
        }

        _.map(values, (item2: any) => {
            valuesCollection[item2] = undefined;
        });

        return valuesCollection;
    };

    _removeColor = (attrValue) => {
        let obj = $.extend(true, {}, this.props.attrColorMapping);
        delete obj[attrValue];

        //LL: 10.10.20: try parentColors
        if (this.props.parentColors != null) {
            let parentColor = this.props.parentColors[attrValue];
            if (parentColor != null) {
                obj[attrValue] = parentColor;
            }
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj);
        }

        this.handleEntityModelsStoreChange(); // to update the view with new color
    };

    handleChange = (attrValue, attrColor) => {
        let obj = $.extend(true, {}, this.props.attrColorMapping);
        obj[attrValue] = attrColor;

        //LL: 02.03.20: always exist at least default
        if (obj[this.undef_key] == null) {
            obj[this.undef_key] = this.defaultColor;
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj);
        }
    };

    //LL: 20.07.20: commented
    //private cnt: number = 0;  //LL: 19.05.17

    _getListView = () => {
        let _self = this;

        let attrValuesCollection = this._getDictionary();
        let valueColorList = _.extend({}, attrValuesCollection, this.props.attrColorMapping);
        let ii = 0;

        let hasOwnValueForUndefKey = this.props.attrColorMapping[this.undef_key] != null;

        //LL: 19.05.17: comment
        // Warning: AttrValueColorSelect is changing an uncontrolled input of type color to be controlled. Input elements should not switch from uncontrolled to controlled (or vice versa). Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://fb.me/react-controlled-components
        // TEMP: use this.cnt, otherwise color is not always changed - React !!!

        //LL: sort for undef_key:
        let keys = _.without(_.keys(valueColorList), 'null');
        keys.sort((a, b) => {
            //  a & b - strings
            if (a === _self.undef_key) return -1;
            else if (b === _self.undef_key) return 1;
            else {
                let n = a.localeCompare(b);
                return n;
            }
        });

        let valueColor = _.map(keys, (val) => {
            let str = valueColorList[val];

            ii++;
            //let k = ii + _self.cnt; //LL: 19.05.17  //LL: 20.07.20: was commented long ago
            let k = ii;

            //LL: 19.05.17: possibility to remove assignment
            let hasValue = str != null && str != undefined;

            if (hasValue) {
                if (val === _self.undef_key) {
                    hasValue = hasOwnValueForUndefKey;
                }
            }

            //LL: 10.10.20: try parentColors
            let hasParentColor = false;
            let hasEqualParentColor = false;
            if (this.props.parentColors != null) {
                hasParentColor = this.props.parentColors[val] != null;
                if (hasValue) {
                    hasEqualParentColor = this.props.parentColors[val] != null && this.props.parentColors[val] === str;
                }
            }

            let removeValue;
            if (hasValue) {
                //removeValue =
                //    <span
                //        className="glyphicon glyphicon-remove"
                //        onClick={ function () {
                //            _self._removeColor(val);
                //        } }
                //    >
                //    </span>;

                //LL: 10.10.20: try parentColors
                if (hasEqualParentColor) {
                    removeValue = (
                        <span className="glyphicon glyphicon-arrow-down" title={'Inherited from parent'}></span>
                    );
                } else {
                    removeValue = (
                        <span
                            className="glyphicon glyphicon-remove"
                            onClick={function () {
                                _self._removeColor(val);
                            }}
                        ></span>
                    );
                }
            }

            //LL: 22.07.20:  add popupPriority={ popupPriority }
            return (
                <tr key={k}>
                    <td className="cell-name">{val}</td>
                    <td className="cell-remove">{removeValue}</td>
                    <td className="cell-color">
                        <ColorBoxField
                            value={str}
                            hideTransparency={true}
                            showText={false}
                            onChange={function (valColor) {
                                _self.handleChange(val, valColor);
                                _self.handleEntityModelsStoreChange(); // to update the view with new color
                            }}
                            themeObj={this.props.themeObj}
                            glob={this.props.glob}
                        />
                    </td>
                </tr>
            );
        });

        //LL: 20.07.20: commented
        //this.cnt += ii;

        if (valueColor.length === 0) {
            valueColor = [
                <tr key="1">
                    <td>
                        <em>{'no values...'}</em>
                    </td>
                    <td></td>
                    <td></td>
                </tr>
            ];
        }

        //LL: 15.07.20: note:
        //   I found that entities-table is defined in pdc-widget-entity-model-editor/common.sass

        //LL: 20.07.20: was <table className="table entities-table" >  No need here

        //LL: 15.07.20: add own <td> for "remove"

        return (
            <table className="table">
                <thead>
                    <tr>
                        <th className="cell-name">{'Attribute Value'}</th>
                        <th className="cell-remove"></th>
                        <th className="cell-color">{'Color'}</th>
                    </tr>
                </thead>

                <tbody>{valueColor}</tbody>
            </table>
        );
    };

    render() {
        let content;

        const loading = this.props.glob.AttrQueryStore.entityValuesAreLoading(this.props.dataSourceID, {
            attribute: this.props.attribute,
            loadKeyAttribute: GET_KEY_ATTRIBUTE_FOR_VALUES
        });

        if (loading) {
            content = <ProgressBar />;
        } else {
            content = this._getListView();
        }

        //LL: 15.07.20: add class .attr-value-color-select  (add "attr-value-color-select.sass")
        return <div className="attr-value-color-select">{content}</div>;
    }
}
